import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 pb-12 border-b border-background/15">
          {/* Brand */}
          <div className="space-y-4 lg:col-span-1">
            <img
              src="https://vibe.filesafe.space/1778679421893490393/attachments/45d9bd93-e98b-4f65-bfcf-0d98c7cfc665.png"
              alt="JNN Homes Logo"
              className="h-12 w-auto object-contain brightness-0 invert"
            />
            <p className="text-sm text-background/70 leading-relaxed">
              Expert full-service Airbnb management for homeowners across VA &
              DC. Active STR investor and Airbnb Superhost.
            </p>
            <div className="flex items-center gap-2 text-sm text-background/80">
              <Phone className="w-4 h-4 text-primary" />
              <a
                href="tel:7038905425"
                className="hover:text-primary transition-colors"
              >
                (703) 890-5425
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-background/50">
              Services
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/services"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Airbnb Management
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Pricing & Packages
                </Link>
              </li>
              <li>
                <Link
                  to="/calculator"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Cash Flow Calculator
                </Link>
              </li>
              <li>
                <Link
                  to="/furniture"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Furnishing List
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Resources & Insights
                </Link>
              </li>
              <li>
                <Link
                  to="/videos"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Watch
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-background/50">
              Service Areas
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/airbnb-management-alexandria"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Alexandria
                </Link>
              </li>
              <li>
                <Link
                  to="/airbnb-management-arlington"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Arlington
                </Link>
              </li>
              <li>
                <Link
                  to="/airbnb-management-fairfax"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Fairfax County
                </Link>
              </li>
              <li>
                <Link
                  to="/airbnb-management-loudoun"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Loudoun County
                </Link>
              </li>
              <li>
                <Link
                  to="/airbnb-management-prince-william"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Prince William
                </Link>
              </li>
              <li>
                <Link
                  to="/airbnb-management-washington-dc"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Washington, D.C.
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-background/50">
              Company
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  About JNN Homes
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.jnnhomes.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Blog
                </a>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-background/80 hover:text-primary transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
            <div className="flex items-start gap-2 text-sm text-background/70 pt-2">
              <MapPin className="w-4 h-4 text-primary shrink-0 mt-0.5" />
              <span>
                Serving Alexandria City, Arlington, Fairfax, Loudoun, Prince
                William and Washington, D.C. neighborhoods from Capitol Hill to
                Georgetown.
              </span>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-background/50">
          <p>© 2026 JNN Homes. All rights reserved. Registered in Virginia.</p>
          <p className="text-background/40">
            JNN Management, LLC DBA JNN Homes
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
